module.exports = "<div class=\"tabs-content\" [ngClass]=\"{'is-content-active':active}\">\n  <ng-content></ng-content>\n</div>"